/**
 * Yabbr Function call to populate widget.
 *
 * @param field <String> Key for which field to populate in the form.
 * @param value <Text> Value to populate the :Key
 */
export function populateWidget(field, value) {
    (<any>window).yabbr(`field:${field}`, value);
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/yabbr.utils.ts